import Vue from 'vue'
import firebase from '../../firebase'

function initialDonationState() {
    return {
        key: null,
        updateddate: null,
        createddate: null,
        formWizardCurrentStep: null,
        url: null,
        method: null,
        // Step1        
        isGift: false,
        packagecode: null,
        type: null, // Single/Regular selected
        campaignid: null,
        fundid: null,
        amount: null,
        dollarhandle: null,
        email: null,
        optin: true,
        // Step2    
        isBehalfBusiness: false,
        bussiness: {
            name: null
        },
        title: null,
        firstname: null,
        lastname: null,
        phone: null,
        billing: {
            unitnumber: null,
            streetno: null,
            streetname: null,
            postcode: null,
            state: '',
            suburb: null,
            country: null
        },
        isSameAddress: true,
        gift: {
            title: null,
            firstname: null,
            lastname: null,
            unitnumber: null,
            streetno: null,
            streetname: null,
            postcode: null,
            state: null,
            suburb: null,
            country: null
        },
        wildcard: {
            dear: null,
            message: null,
            email: null,
            scheduledate: null,
            img: null,
            pdf: null
        },
        payementType: 'wwf_purchasetokenise',
        isProcessing: false
    }
}

const state = {
    donation: initialDonationState()
}

const getters = {
    donation: state => state.donation
}

const mutations = {
    updateDonation: function (state, { field, value }) {
        console.log("updatedonation", field, value);
        // console.log('Update Donation::state.donation::before', JSON.parse(JSON.stringify(state.donation)));
        if (value != undefined) {
            Object.assign(state.donation, {
                [field]: value
            });
        }
        // console.log('Update Donation::state.donation::after', JSON.parse(JSON.stringify(state.donation)));
    },
    updateDonationBussiness: function (state, { field, value }) {
        console.log("updateDonationBussiness", field, value);
        if (value != undefined) {
            Object.assign(state.donation.bussiness, {
                [field]: value
            });
        }
    },
    updateDonationBilling: function (state, { field, value }) {
        console.log("updateDonationBilling", field, value);
        if (value != undefined) {
            Object.assign(state.donation.billing, {
                [field]: value
            });
        }
    },
    updateDonationGift: function (state, { field, value }) {
        console.log("updateDonationGift", field, value);
        if (value != undefined) {
            Object.assign(state.donation.gift, {
                [field]: value
            });
        }
    },
    updateDonationWildcard: function (state, { field, value }) {
        console.log("updateDonationWildcard", field, value);
        if (value != undefined) {
            Object.assign(state.donation.wildcard, {
                [field]: value
            });
        }
    },
    resetDonation: function () {
        console.log("resetDonation mutation", state);
        const s = initialDonationState()
        Object.keys(s).forEach(key => {
            state.donation[key] = s[key]
        })
    }
}

const actions = {
    saveDonationStep1: function ({ dispatch, state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            console.log('saveDonationStep1 State donation', state.donation)
            var date = new Date();

            const donation = {
                isGift: state.donation.isGift,
                packagecode: state.donation.packagecode,
                type: state.donation.type, // Single/Regular selected
                amount: state.donation.amount,
                dollarhandle: state.donation.dollarhandle,
                email: state.donation.email,
                optin: state.donation.optin,
                appealid: rootState.product.product.appealcodesetting.appealid,
                campaignid: state.donation.campaignid,
                fundid: state.donation.fundid,
                producttype: rootState.product.product.producttype,
                productname: rootState.product.product.productname,
                productid: rootState.product.product.id,
                certificateurl: (rootState.product.product.certificateurl) ? rootState.product.product.certificateurl : null,
                source: rootState.product.product.source,
                formWizardCurrentStep: state.donation.formWizardCurrentStep
            }

            console.log('saveDonationStep1 Donation', donation)

            // if donation already exist
            if (state.donation.key) {
                donation.updateddate = date.toISOString();
                firebase.database.ref("pending-donations").child(state.donation.key)
                    .update(donation, function (error) {
                        if (error) {
                            console.log('Error has occured during saving step1 set process', error)
                            reject(error);
                        }
                        else {
                            console.log('saveDonation Step 1 set success')
                            resolve();
                        }
                    }).then(function (result) {
                        console.log("saveDonation Step 1 set:", result);
                    })
            }
            else {
                donation.createddate = date.toISOString();
                donation.updateddate = donation.createddate;
                firebase.database.ref("pending-donations")
                    .push(donation, function (error) {
                        if (error) {
                            console.log('Error has occured during saving step1 push process', error)
                            reject(error);
                        }
                        else {
                            console.log('saveDonation Step 1 push success')
                        }
                    }).then(function (result) {
                        console.log("saveDonation Step 1 push: ", result);
                        commit("updateDonation", { field: 'key', value: result.key });
                        resolve();
                    })
            }
        })
    },
    saveDonationStep2: function ({ dispatch, state, commit }) {
        return new Promise((resolve, reject) => {
            console.log('saveDonationStep2 State donation', state.donation)
            console.log('saveDonationStep2 State product', state.product)
            var date = new Date()

            const donation = {
                isGift: state.donation.isGift,
                type: state.donation.type, // Single/Regular selected
                bussiness: state.donation.isBehalfBusiness ? {
                    name: state.donation.bussiness.name
                } : null,
                title: state.donation.title,
                firstname: state.donation.firstname,
                lastname: state.donation.lastname,
                phone: state.donation.phone,
                billing: {
                    unitnumber: state.donation.billing.unitnumber,
                    streetno: state.donation.billing.streetno,
                    streetname: state.donation.billing.streetname,
                    postcode: state.donation.billing.postcode,
                    state: state.donation.billing.state,
                    suburb: state.donation.billing.suburb,
                    country: state.donation.billing.country
                },
                isSameAddress: state.donation.isSameAddress,
                gift: state.donation.isGift ? {
                    title: state.donation.gift.title,
                    firstname: state.donation.gift.firstname,
                    lastname: state.donation.gift.lastname,
                    unitnumber: !state.donation.isSameAddress ? state.donation.gift.unitnumber : null,
                    streetno: !state.donation.isSameAddress ? state.donation.gift.streetno : null,
                    streetname: !state.donation.isSameAddress ? state.donation.gift.streetname : null,
                    postcode: !state.donation.isSameAddress ? state.donation.gift.postcode : null,
                    state: !state.donation.isSameAddress ? state.donation.gift.state : null,
                    suburb: !state.donation.isSameAddress ? state.donation.gift.suburb : null,
                    country: !state.donation.isSameAddress ? state.donation.gift.country : null
                } : null,
                wildcard: {
                    dear: state.donation.wildcard.dear,
                    message: state.donation.wildcard.message,
                    email: state.donation.wildcard.email,
                    scheduledate: state.donation.wildcard.scheduledate,
                    img: state.donation.wildcard.img,
                    pdf: state.donation.wildcard.pdf
                },
                payementType: state.donation.payementType,
                formWizardCurrentStep: state.donation.formWizardCurrentStep
            }

            console.log('saveDonationStep2 Donation', donation)

            donation.updateddate = date.toISOString();
            firebase.database.ref("pending-donations").child(state.donation.key)
                .update(donation, function (error) {
                    if (error) {
                        console.log('Error has occured during saving step2 set process', error)
                        reject(error);
                    }
                    else {
                        console.log('saveDonation Step 2 set success')
                        resolve();
                    }
                }).then(function (result) {
                    console.log("saveDonation Step 2 set:", result);
                })
        })
    },
    excecutePayment: function ({ }, data) {
        state.donation.isProcessing = true
        return new Promise((resolve, reject) => {
            console.log('excecutePayment', data)
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + wwfconfigs.PAYPALEXECUTE, {
                paymentid: data.paymentid,
                payerid: data.payerid
            }).then(response => {
                state.donation.isProcessing = false
                console.log("excecutePayment log", response)
                if (response && response.body && response.body.status == 'success' && response.body.data) {
                    resolve(response.body.data)
                }
                else {
                    resolve()
                }
            }, error => {
                state.donation.isProcessing = false
                console.error("excecutePayment error", error)
                resolve()
            });
        })
    },
    resetDonation: function ({ commit }) {
        commit("resetDonation");
    },
    retryDonation: async function ({ commit, dispatch }) {
        commit("updateDonation", { field: "key", value: '' }); // value: '' ????
        await dispatch("saveDonationStep1")
        return await dispatch("saveDonationStep2")
    },
    checkout: function ({ dispatch, state, commit, rootState }) {
        console.log('checkout', state)
        commit("updateDonation", { field: 'method', value: '' });
        commit("updateDonation", { field: 'url', value: '' });
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + wwfconfigs.CHECKOUT, {
                // The method doesnt like the amount with. 
                amount: state.donation.amount.replace(',', ''),
                //amount: state.donation.amount
                paymentType: state.donation.payementType,
                email: state.donation.email,
                custRef: state.donation.key,
                productid: rootState.product.product.id,// ok
                productname: rootState.product.product.productname, // ok
                producttype: rootState.product.product.producttype, // Ok
                campaignid: rootState.product.product.appealcodesetting.campaignid, // ok
                fundid: rootState.product.product.appealcodesetting.fundid, //ok 
                appealid: rootState.product.product.appealcodesetting.appealid,//ok
                type: state.donation.type,
                source: rootState.product.product.source
            }).then(response => {
                console.log("checkout", response)
                commit("updateDonation", { field: 'method', value: response.body.method });
                commit("updateDonation", { field: 'url', value: response.body.url });
                resolve(response)
            }, error => {
                console.error("checkout", error)
                reject(error)
            });
        })
    },
}

export default {
    state,
    actions,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/donate.js